import { z } from 'zod';
import { PMF_MASS_TOLERANCE, type Pmf } from '@sharpr/pricing';

// A PMF's bins as JSON Schema can say them: the wire members build on it.
export const pmfBins = (maxBins: number) => z.array(z.number().min(0).max(1)).min(1).max(maxBins);

// Mass is the one PMF invariant zod's min/max cannot express; it is re-asserted in Python (§13.9).
export const pmfSchema = (maxBins: number): z.ZodType<Pmf> =>
  pmfBins(maxBins).refine(pmf => Math.abs(pmf.reduce((a, b) => a + b, 0) - 1) <= PMF_MASS_TOLERANCE, 'PMF mass must be 1 ± 1e-9');
